module.exports = __webpack_public_path__ + "media/more_review_app/assets/images/icon_next-df1d854415797598f17fa706e283093a.svg";